module.exports = __webpack_public_path__ + "dist/img/allincu-logo.438116b9.png";